


































































































































































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import store from "../../store";
import { germanZahl } from "../../helper/utils";

@Component
export default class Widget extends Vue {
  @Prop() layoutClass!: string;
  @Prop() headClass!: string;
  @Prop() firstTitle!: string;
  @Prop() secondTitle!: string;
  @Prop() thirdTitle!: string;
  @Prop() headIcon!: string;
  @Prop() hideYear!: boolean;
  @Prop() helpIcon!: boolean;
  @Prop() helpIconId!: string;
  @Prop() hideFooter!: boolean;
  @Prop() showVersion!: boolean;
  @Prop() showSwitch!: boolean;
  @Prop() addButtonName!: boolean;
  @Prop() searchTable!: boolean;
  @Prop({ default: false }) plan!: boolean;
  @Prop({ default: false }) showCusttomRightTmpl!: boolean;

  oposRange = 90;
  searchVal = "";

  get year() {
    return store.getters.selectedYear;
  }

  get currentCalcs() {
    return store.getters.currentCalcs;
  }

  get yearSums() {
    return store.getters.currentYearSums;
  }

  get planYear() {
    return store.getters.planYear;
  }

  formattedVal(val: any) {
    return germanZahl(val.toFixed(2));
  }

  @Emit("rangeChanged")
  changeOposRange() {
    return this.oposRange;
  }

  @Emit("add")
  add() {
    return true;
  }

  @Emit("search")
  search() {
    return this.searchVal;
  }
}
